import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "clm-act-cntn" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Atur ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down text-black ml-4" }, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import numberFormat from '@/utils/helpers/numberFormat'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import EmptyState from '@/views/components/list/EmptyState.vue'
import ListActions from '@/views/components/list/ListActions.vue'
import Paginator from '@/views/components/paginator/Paginator.vue'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import InputSwitch from 'primevue/inputswitch'
import OverlayPanel from 'primevue/overlaypanel'
import ProgressSpinner from 'primevue/progressspinner'
import { getCurrentInstance, onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import apiUseCase from '@/usecase/apiUseCase'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const bundleEndpoint = 'ticket/v1/Bundles'
const store = useStore()
const router = useRouter()
const app = getCurrentInstance()
const {
  $toast, $confirm
} = app!.appContext.config.globalProperties
const isLoading = ref(false)
const emptyTable = ref('Data belum ada, silahkan tambah untuk mengisi data')
const headerTitle = ref('Paket Langganan')
const buttonTitle = ref('Tambah Paket')
const searchPlaceholder = ref('Cari Disini...')
const refOverlayAction = ref()
const dataRow = ref(null) as any
const dataSource = ref([]) as any

const filters = {
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  custom: [] as any
}

const attrModalConfirmation = reactive({
  show: false,
  title: 'Hapus Paket Langganan?',
  subTitle: 'Data paket langganan tersebut akan dihapus dalam sistem. Yakin hapus paket langganan?',
  btnSubmitTitle: 'Hapus Paket Langganan',
  imgContent: require('@/assets/img/modal-confirmation/delete-default.svg')
})

const onClickBtnAdd = () => {
  console.log('add')
  router.push({ name: 'ticket-subscription-form' })
}

const onSearch = (val: any) => {
  console.log('search', val)
  filters.search = val
  filters.pageNumber = 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const onEdit = () => {
  refOverlayAction.value.hide()
  const encryptedData = encryptDecriptMethods.encrypt(dataRow.value)
  router.push({ name: 'ticket-subscription-form', params: { id: encryptedData } })
}

const hideDialogConfirmation = () => {
  attrModalConfirmation.show = false
  dataRow.value = null
}

const onDeleteConfirmation = async () => {
  store.dispatch('showLoading')
  await apiOpenUseCase.delete(bundleEndpoint, dataRow.value.Id).then((response) => {
    const { error, message } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Paket Langganan dihapus',
        group: 'bc',
        closable: false,
        life: 3000
      })
      // eslint-disable-next-line no-use-before-define
      getAllData()
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Gagal',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  hideDialogConfirmation()
  store.dispatch('hideLoading')
}

const onDelete = () => {
  refOverlayAction.value.hide()
  console.log('dataRow', dataRow.value)
  attrModalConfirmation.show = true
}

const onSort = (event: any) => {
  console.log('sort', event)
  filters.custom = [['OrderBy', '=', `${event.sortField} ${event.sortOrder === 1 ? 'asc' : 'desc'}`]]
  filters.pageNumber = 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const onChangePage = ({ page }: any) => {
  filters.pageNumber = page + 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const changeIsActive = (item: any) => {
  console.log('changeIsActive', item)
  $confirm.require({
    header: `${!item.IsActive ? 'Nonaktifkan' : 'Aktifkan'} Paket Langganan`,
    message: 'Apakah anda yakin ingin mengubahnya?',
    icon: 'pi pi-exclamation-triangle',
    accept: async () => {
      store.dispatch('showLoading')
      const payload = {
        IsActive: item.IsActive
      }
      await apiOpenUseCase.patchWithNoId(`${bundleEndpoint}/${item.Id}/Activation`, payload).then((response) => {
        const { error, message } = response
        if (!error) {
          $toast.add({
            severity: 'success',
            detail: `Paket Langganan berhasil ${item.IsActive ? 'diaktifkan' : 'dinonaktifkan'}`,
            group: 'bc',
            closable: false,
            life: 3000
          })
        } else {
          $toast.add({
            severity: 'error',
            summary: 'Gagal',
            detail: message,
            group: 'bc',
            closable: false,
            life: 3000
          })
          item.IsActive = !item.IsActive
        }
      })
      store.dispatch('hideLoading')
    },
    reject: () => {
      item.IsActive = !item.IsActive
    }
  })
}

const showDropDown = (evt: any, item: any) => {
  dataRow.value = item
  console.log('dataRow', dataRow.value)
  refOverlayAction.value.toggle(evt)
}

const getAllData = async () => {
  store.dispatch('showLoading')
  await apiOpenUseCase.get(bundleEndpoint, returnUrlPrams(filters)).then((response) => {
    console.log('res', response)
    const { error, result, count } = response
    if (!error) {
      dataSource.value = result
      filters.totalRecords = count
    }
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  // console.log('ASDADA')
  getAllData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(HeaderCustom, {
            titleHeader: headerTitle.value,
            titleButton: buttonTitle.value,
            onRedirectAdd: onClickBtnAdd,
            placeholder: searchPlaceholder.value,
            onOnSearch: onSearch,
            showSearch: true,
            showAddBtn: true
          }, null, 8, ["titleHeader", "titleButton", "placeholder"])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(DataTable), {
          id: "hjp-data-table",
          value: _unref(dataSource),
          paginator: false,
          loading: isLoading.value,
          class: "table-og hjp-data-table",
          responsiveLayout: "scroll",
          lazy: true,
          onSort: onSort
        }, {
          empty: _withCtx(() => [
            _createVNode(EmptyState, { textNoData: emptyTable.value }, null, 8, ["textNoData"])
          ]),
          loading: _withCtx(() => [
            _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              header: "Produk",
              field: "BundleName",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.BundleName ?? '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Harga",
              field: "TotalBundlePrice",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_unref(rupiahFormat)(slotProps.data.TotalBundlePrice ?? 0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Diskon",
              field: "TotalDiscount"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_unref(numberFormat)(slotProps.data.TotalDiscount ?? 0)) + " % ", 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Penjualan",
              field: "TotalSold",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_unref(numberFormat)(slotProps.data.TotalSold ?? 0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Max Pembelian",
              field: "MaxPurchase",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_unref(numberFormat)(slotProps.data.MaxPurchasePerUser ?? 0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Aktif" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(InputSwitch), {
                    modelValue: slotProps.data.IsActive,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.IsActive) = $event),
                    onChange: ($event: any) => (changeIsActive(slotProps.data))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              class: "colom-action mx-auto",
              header: "Aksi"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "px-4 py-2 flex items-center cursor-pointer rounded-lg background-grey-lighten-5",
                    onClick: ($event: any) => (showDropDown($event, slotProps.data))
                  }, _hoisted_7, 8, _hoisted_4)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"]),
        _createVNode(_unref(OverlayPanel), {
          ref_key: "refOverlayAction",
          ref: refOverlayAction
        }, {
          default: _withCtx(() => [
            _createVNode(ListActions, {
              edit: true,
              del: true,
              editTitle: 'Edit',
              delTitle: 'Hapus',
              onDel: onDelete,
              onEdit: onEdit
            })
          ]),
          _: 1
        }, 512)
      ]),
      footer: _withCtx(() => [
        (filters.totalRecords > 0)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              rows: filters.pageSize,
              totalRecords: filters.totalRecords,
              onOnPage: onChangePage
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(HjpCofirmModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: onDeleteConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle"])
  ]))
}
}

})